(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["localization-selector"] && !Shopify.designMode) return;
  try {
    class CountrySelectorComponent extends HTMLElement {
    connectedCallback() {
      this.wrapper = this.querySelector('.country-selector__wrapper');
      this.button = this.querySelector('.country-selector__button');

      if (!this.wrapper || !this.button) return;

      this.button.addEventListener('click', this.toggle);
      document.addEventListener('click', this.handleClickOutside);
      document.addEventListener('keydown', this.handleKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleClickOutside);
      document.removeEventListener('keydown', this.handleKeydown);
    }

    toggle = () => {
      this.wrapper.classList.contains('active') ? this.close() : this.open();
    };

    open = () => {
      this.wrapper.classList.add('active');
      this.button.setAttribute('aria-expanded', 'true');
    };

    close = () => {
      this.wrapper.classList.remove('active');
      this.button.setAttribute('aria-expanded', 'false');
    };

    handleClickOutside = (event) => {
      if (!this.wrapper.contains(event.target)) this.close();
    };

    handleKeydown = (event) => {
      if (event.key !== 'Escape' || !this.wrapper.classList.contains('active')) return;
      this.close();
      this.button.focus();
    };
  }

  if (!customElements.get('country-selector-component')) {
    customElements.define('country-selector-component', CountrySelectorComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
